import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Transaction } from 'src/app/models';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { createMerchantReturnUrl } from 'src/app/shared/helps/helps';
import { environment } from 'src/environments/environment';

interface InfoOrderCheckout {
    orderID: string;
    paymentsLength: number;
}
@Component({
    selector: 'app-amount-to-low-alert',
    templateUrl: './amount-to-low-alert.component.html',
    styleUrls: ['./amount-to-low-alert.component.scss'],
})
export class AmountToLowAlertComponent implements OnInit {
    @Input() infoOrderCheckout: InfoOrderCheckout;
    @Input() transaction: Transaction;
    @Output() CDC = new EventEmitter();
    limitsMessage: string;
    checkoutToken: string;

    constructor(private tokenService: TokenServiceService) {}

    ngOnInit(): void {
        this.limitsMessage = 'alert-Cdc-limits-Below-Allowed';
        this.checkoutToken = this.tokenService.getToken();
    }
    /**
     *
     * @description {returnMethods} Function to redirect the user to the payment methods or url of the merchant
     */
    returnMethods() {
        if (this.infoOrderCheckout.paymentsLength > 0) {
            this.changeMethod();
            return;
        }
        let urlToRedirect = this.buildMerchantUrl(this.transaction.MERCHANT_URL_RETURN, this.infoOrderCheckout.orderID);
        window.location.href = urlToRedirect ?? '';
    }
    /**
     * @description {changeMethod} Function that returns to payment methods
     */
    changeMethod() {
        this.CDC.emit();
    }

    /**
     *
     * @description {buildMerchantUrl} Function to validate the queryParams that come from the checkout and build the urls of the component
     * @param params
     * @returns
     */
    buildMerchantUrl = (urlMerchant: string, orderCode: string) => {
        let urlToRedirect = `${environment.host}?token=${this.checkoutToken}`;

        if (urlMerchant && orderCode) urlToRedirect = createMerchantReturnUrl(orderCode.toString(), urlMerchant);

        return urlToRedirect;
    };
}
